import { toast } from 'react-toastify';

const alert = {
  success: (message, options = {}) => {
    toast.success(message, {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path
            d="M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM10 18C12.1217 18 14.1566 17.1571 15.6569 15.6569C17.1571 14.1566 18 12.1217 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2C7.87827 2 5.84344 2.84285 4.34315 4.34315C2.84285 5.84344 2 7.87827 2 10C2 12.1217 2.84285 14.1566 4.34315 15.6569C5.84344 17.1571 7.87827 18 10 18ZM9.003 14L4.76 9.757L6.174 8.343L9.003 11.172L14.659 5.515L16.074 6.929L9.003 14Z"
            fill="white"
          />
        </svg>
      ),
      ...options
    });
  },
  error: (message, options = {}) => {
    toast.error(message, {
      // api.onError ÑÐ¶Ðµ Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÑ ÑÐ¾ÑÑ Ñ Ð¿ÑÐ¸ÑÐ¸Ð½Ð¾Ð¹ Ð¾Ñ Ð±ÑÐºÐµÐ½Ð´Ð°, Ð¸ ÑÐ¾Ñ Ð¶Ðµ ÑÐµÐºÑÑ
      // ÑÐºÑÐ°Ð½ Ð´Ð¾ÑÑÐ°ÑÑ Ð² ÑÐ²Ð¾ÑÐ¼ .catch ÑÐµÑÐµÐ· extractErrorMessage. ÐÐ´Ð¸Ð½Ð°ÐºÐ¾Ð²ÑÐ¹ id
      // Ð½Ðµ Ð´Ð°ÑÑ Ð¿Ð¾ÐºÐ°Ð·Ð°ÑÑ Ð¾Ð´Ð½Ð¾ ÑÐ¾Ð¾Ð±ÑÐµÐ½Ð¸Ðµ Ð´Ð²Ð°Ð¶Ð´Ñ.
      toastId: typeof message === 'string' ? message : undefined,
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_1256_38975)">
            <path
              d="M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22ZM12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20ZM11 15H13V17H11V15ZM11 7H13V13H11V7Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_1256_38975">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
      ...options
    });
  },
};

export default alert;
